import type { IncomingMessage } from 'http'

export type RequestWithHeaders = Pick<IncomingMessage, 'headers'>

export const getHeader = (req: RequestWithHeaders, name: string) => {
  const header = req.headers[name]

  return Array.isArray(header) ? header[0] : header
}
